import { render, staticRenderFns } from "./SelectedProductList.vue?vue&type=template&id=07347a6c"
import script from "./SelectedProductList.vue?vue&type=script&lang=js"
export * from "./SelectedProductList.vue?vue&type=script&lang=js"
import style0 from "./SelectedProductList.vue?vue&type=style&index=0&id=07347a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports